import { TargetMarketFiltersType } from './types';

export const ONBOARDING_STEPS = [1, 2, 3, 4, 5];
export const ONBOARDING_ICP_AUDIENCE_NAME = 'Main ICP';

export const DEFAULT_FILTERS: TargetMarketFiltersType = {
  businessModel: ['B2B'],
  country: ['United States'],
  employees: [],
  industry: ['Consumer Services', 'IT Services', 'Professional Services'],
  raised: [],
  tag: [],
  tech: [],
  type: [],
};

export const BUSINESS_MODELS = [
  {
    label: 'B2B',
    value: 'B2B',
  },
  {
    label: 'B2C',
    value: 'B2C',
  },
];

export const COMPANY_TYPES = [
  { label: 'Education', value: 'education' },
  { label: 'Government', value: 'government' },
  { label: 'Non-profit', value: 'nonprofit' },
  { label: 'Private', value: 'private' },
  { label: 'Public', value: 'public' },
];

export const RAISED_RANGES = [
  { label: '$0-$1M', value: '0~1000000' },
  { label: '$1M-$10M', value: '1000001~10000000' },
  { label: '$10M-$50M', value: '10000001~50000000' },
  { label: '$50M-$100M', value: '50000001~100000000' },
  { label: '$100M+', value: '100000001~' },
];
